import React, { HTMLAttributes } from 'react'
import { cn } from '~/utils'

export type BadgeProps = HTMLAttributes<HTMLSpanElement>

export const Badge: React.FC<BadgeProps> = ({ className, ...props }) => (
	<span
		className={cn(
			'inline-block rounded-full bg-green-300 px-5 py-1 text-lg font-bold tracking-wide text-green-700',
			className
		)}
		{...props}
	/>
)
